import React, { useState } from 'react';
import { Range } from 'react-range';

interface PriceRangeSliderProps {
  min: number;
  max: number;
  valueMin: number;
  valueMax: number;
  onChange: (min: number, max: number) => void;
}

export const PriceRangeSlider: React.FC<PriceRangeSliderProps> = ({
  min,
  max,
  valueMin,
  valueMax,
  onChange,
}) => {
  const [values, setValues] = useState([valueMin, valueMax]);

  const handleChange = (newValues: number[]) => {
    setValues(newValues);
    onChange(newValues[0], newValues[1]);
  };

  return (
    <div className="w-full px-2">
      <Range
        step={100}
        min={min}
        max={max}
        values={values}
        onChange={handleChange}
        renderTrack={({ props, children }) => (
          <div
            {...props}
            className="w-full h-2 bg-slate-200 rounded-full"
            style={{
              ...props.style,
            }}
          >
            {children}
          </div>
        )}
        renderThumb={({ props }) => {
          const { key, ...restProps } = props;
          return (
            <div
              key={key}
              {...restProps}
              className="w-5 h-5 bg-white border-3 border-brand-ocean rounded-full shadow-md hover:shadow-lg transition-shadow focus:outline-none focus:ring-2 focus:ring-brand-ocean focus:ring-offset-2"
              style={{
                ...restProps.style,
              }}
            />
          );
        }}
      />
    </div>
  );
};
